import { render } from "./WhoOwesMeWidget.vue?vue&type=template&id=021d2390"
import script from "./WhoOwesMeWidget.vue?vue&type=script&lang=js"
export * from "./WhoOwesMeWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__